@if (IsInSite()) {
  @if (IsButton()) {
    <button
      class="sheyda-button"
      mat-flat-button
      [title]="Text()"
      [ariaLabel]="Text()"
      [routerLink]="Link()"
      (click)="(click)"
      [ngClass]="[Appearance(), FullWidth() ? 'full-width' : '', Direction(), Icon() || IconImage() ? 'with-icon' : '']"
      [routerLinkActiveOptions]="{
        paths: 'exact',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored',
      }"
      [routerLinkActive]="IsRouterActive() ? 'active' : ''"
      [disabled]="disabled()"
      [type]="Type()"
    >
      <ng-container *ngTemplateOutlet="buttonData"></ng-container>
    </button>
  } @else {
    <a
      class="sheyda-button"
      mat-flat-button
      [title]="Text()"
      [ariaLabel]="Text()"
      [routerLink]="Link()"
      (click)="(click)"
      [ngClass]="[Appearance(), FullWidth() ? 'full-width' : '', Direction(), Icon() || IconImage() ? 'with-icon' : '']"
      [routerLinkActiveOptions]="{
        paths: 'exact',
        queryParams: 'ignored',
        matrixParams: 'ignored',
        fragment: 'ignored',
      }"
      [routerLinkActive]="IsRouterActive() ? 'active' : ''"
      [disabled]="disabled()"
      [type]="Type()"
    >
      <ng-container *ngTemplateOutlet="buttonData"></ng-container>
    </a>
  }
} @else {
  <a
    class="sheyda-button"
    mat-flat-button
    [title]="Text()"
    [ariaLabel]="Text()"
    [href]="Link()"
    (click)="(click)"
    [ngClass]="[Appearance(), FullWidth() ? 'full-width' : '', Direction(), Icon() || IconImage() ? 'with-icon' : '']"
    [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }"
    [routerLinkActive]="IsRouterActive() ? 'active' : ''"
    [disabled]="disabled()"
    [type]="Type()"
  >
    <ng-container *ngTemplateOutlet="buttonData"></ng-container>
  </a>
}

<ng-template #buttonData>
  @if (loading()) {
    <app-loading-spinner [Size]="32" />
  } @else {
    @if (Text()) {
      <span>{{ Text() }}</span>
    }
    @if (Icon()) {
      <mat-icon [fontSet]="IsFillIcon() ? 'mat-symbol-round-fill' : 'mat-symbol-round'">{{ Icon() }}</mat-icon>
    }
    @if (IconImage()) {
      <app-image-generator [src]="IconImage()!" [name]="Text()" imageType="original" [noBlurPlaceholder]="true" />
    }
  }
</ng-template>
